/** /managerDashboard/vehicles
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20VehicleNamesResponseDto
 */
export const getVehiclesRespAviation = () => {
  return {
    vehicleTypes: ["A339", "A330", "B787", "A346", "B744", "A332", "A351"],
    vehicleIds: [
      "G-VMIK",
      "G-VNYL",
      "G-VINE",
      "G-VLIB",
      "G-VLIP",
      "G-VWOO",
      "G-VWEB",
      "G-VAHH",
      "G-VKSS",
      "G-VLNM",
      "G-VROM",
      "G-VWHO",
      "G-VMAP",
      "G-VBEL",
      "G-VPRD",
      "G-VWAG",
      "G-VYUM",
      "G-VZIG",
      "G-VRAY",
      "G-VJAZ",
      "G-VROY",
      "G-VLUV",
      "G-VTOM",
      "G-VRNB",
      "G-VEII",
      "G-VBOW",
      "G-VJAM",
      "G-VUFO",
      "G-VSXY",
      "G-VFIT",
      "G-VTEA",
      "G-VMNK",
      "G-VFAN",
      "G-VBOB",
      "G-VNAP",
      "G-VNYC",
      "G-NIKO",
      "G-VRED",
      "G-VBUG",
      "G-VEVE",
      "G-VGAL",
      "G-VNEW",
      "G-VBZZ",
      "G-VROS",
      "G-VAST",
      "G-VXLG",
      "G-VGEM",
      "G-VOWS",
      "G-VWIN",
      "G-VSPY",
      "G-VWND",
      "G-VGBR",
      "G-VYOU",
      "G-VBIG",
      "G-VLUX",
      "G-VLDY",
      "G-VOOH",
      "G-VDOT",
      "G-VCRU",
      "G-VPOP",
      "G-VDIA",
      "G-VBOB",
    ],
    vehicleCount: 62,
  };
};
